import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Select, Button, Icon } from 'antd'
import { subscriptions } from '@services/api'

@inject((store: any) => {
    const { popupStore, authStore } = store
    return { popupStore, authStore }
})
@observer
export default class extends Component {
    constructor(props) {
        super(props)
        const { child, partner, parent, price, type, iteration_type, min_age, max_age, id, quantity } = props.item

        this.state = {
            child,
            partner,
            parent,
            price,
            type,
            iteration_type,
            min_age,
            max_age,
            id,
            quantity
        }
    }

    render() {
        const {
            popupStore: { togglePopup },
            item: { services },
            authStore,
            refreshSubs
        } = this.props
        const { child, partner, parent, price, type, iteration_type, min_age, max_age, id, quantity } = this.state

        let spanStyle = { marginTop: 7.5, marginRight: 7.5 }
        return (
            <div style={{ flexDirection: 'column', display: 'flex', position: 'relative' }}>
                <div style={{ flexDirection: 'row', display: 'flex', position: 'relative' }}>
                    <span style={{ marginTop: 13.5, marginRight: 15.5 }}>
                        מחיר:
                        <input
                            style={{ marginRight: 8, width: 50, marginTop: 14 }}
                            value={price}
                            onChange={e => this.setState({ price: e.target.value })}
                        />
                    </span>
                </div>
                {type == 'AGENT' ? (
                    <span style={{ marginTop: 7.5 }}>
                        הגבלת קליינטים:
                        <input
                            style={{ marginRight: 5, width: 30 }}
                            value={quantity}
                            onChange={e => this.setState({ quantity: e.target.value })}
                        />
                    </span>
                ) : (
                    <div style={{ flexDirection: 'row', display: 'flex', position: 'relative', marginTop: 7.5 }}>
                        <span style={{ marginTop: 7.5 }}>
                            ילדים כלולים:
                            <input
                                style={{ marginRight: 5, width: 30 }}
                                value={child}
                                onChange={e => this.setState({ child: e.target.value })}
                            />
                        </span>
                        <span style={spanStyle}>
                            בן זוג כלול:
                            <input
                                style={{ marginRight: 5, width: 30 }}
                                value={partner}
                                onChange={e => this.setState({ partner: e.target.value })}
                            />
                        </span>
                        <span style={spanStyle}>
                            הורים כלולים:
                            <input
                                style={{ marginRight: 5, width: 30 }}
                                value={parent}
                                onChange={e => this.setState({ parent: e.target.value })}
                            />
                        </span>
                        <span style={spanStyle}>
                            גיל מינימלי:
                            <input
                                style={{ marginRight: 5, width: 30 }}
                                value={+min_age}
                                onChange={e => this.setState({ min_age: e.target.value })}
                            />
                        </span>
                        <span style={spanStyle}>
                            גיל מקסימלי:
                            <input
                                style={{ marginRight: 5, width: 30 }}
                                value={+max_age}
                                onChange={e => this.setState({ max_age: e.target.value })}
                            />
                        </span>
                    </div>
                )}
                <div style={{ flexDirection: 'row', display: 'flex', position: 'relative', marginTop: 7.5 }}>
                    {type != 'AGENT' ? (
                        <>
                            <Select
                                value={type}
                                onChange={type => this.setState({ type })}
                                style={{ width: 250, marginTop: 7.5 }}
                            >
                                <Select.Option value={'PERSONAL'} key={'PERSONAL'}>
                                    אישי
                                </Select.Option>
                                <Select.Option value={'COUPLE'} key={'COUPLE'}>
                                    זוגי
                                </Select.Option>
                                <Select.Option value={'FAMILY'} key={'FAMILY'}>
                                    משפחתי
                                </Select.Option>
                                <Select.Option value={'COUPLE_OLD'} key={'COUPLE_OLD'}>
                                    זוגי - גיל הזהב
                                </Select.Option>
                                <Select.Option value={'PERSONAL_PLUS'} key={'PERSONAL_PLUS'}>
                                    אישי - פלוס
                                </Select.Option>
                                <Select.Option value={'COUPLE_PLUS'} key={'COUPLE_PLUS'}>
                                    זוגי - פלוס
                                </Select.Option>
                                <Select.Option value={'FAMILY_PLUS'} key={'FAMILY_PLUS'}>
                                    משפחתי - פלוס
                                </Select.Option>
                                <Select.Option value={'COUPLE_OLD_PLUS'} key={'COUPLE_OLD_PLUS'}>
                                    זוגי - גיל הזהב - פלוס
                                </Select.Option>
                                <Select.Option value={'PERSONAL_OLD'} key={'PERSONAL_OLD'}>
                                    אישי - גיל הזהב
                                </Select.Option>
                            </Select>
                            <Select
                                value={iteration_type}
                                onChange={iteration_type => this.setState({ iteration_type })}
                                style={{ width: 250, ...spanStyle }}
                            >
                                <Select.Option value={'ONCE'} key={'ONCE'}>
                                    תשלום חד פעמי
                                </Select.Option>
                                <Select.Option value={'MONTHLY'} key={'MONTHLY'}>
                                    חודשי
                                </Select.Option>
                            </Select>
                        </>
                    ) : (
                        ''
                    )}
                </div>
                <div style={{ flexDirection: 'row', display: 'flex', position: 'relative' }}>
                    {type != 'AGENT' ? (
                        <Button
                            disabled={!authStore.roles.includes('admin')}
                            style={{ marginTop: 35.5, marginRight: 7.5, width: 225 }}
                            onClick={() => {
                                togglePopup('manageServicesForSubs', {
                                    services,
                                    subId: id
                                })
                            }}
                        >
                            ערוך שירותים כלולים בחבילה <Icon type="edit" />
                        </Button>
                    ) : (
                        ''
                    )}
                    <Button
                        disabled={!authStore.roles.includes('admin')}
                        style={{ marginTop: 35.5, marginRight: 7.5, width: 225 }}
                        onClick={() =>
                            subscriptions
                                .updateSub({ ...this.state })
                                .then(() => {
                                    alert('מסלול עודכן בהצלחה!')
                                    refreshSubs()
                                })
                                .catch(err => {
                                    console.log({ err })
                                    alert('שגיאה בעדכון מסלול')
                                })
                        }
                    >
                        שמור שינויים <Icon type="check" />
                    </Button>
                </div>
            </div>
        )
    }
}
